export const ACTIVE_OPTION_COLOR = '#FFCC88';
export const INACTIVE_OPTION_COLOR = '#000000';
